'use client';

import { c as _c } from "react/compiler-runtime";
import ImgWrapper from '@components/img-wrapper/ImgWrapper';
import playIcon from '@images/renders/icon_images/playIcon.svg';
import { useEffect, useRef, useState } from 'react';
import Svg from 'react-inlinesvg';
import { ControlBar, CurrentTimeDisplay, ForwardControl, PlaybackRateMenuButton, Player, ReplayControl, TimeDivider, VolumeMenuButton } from 'video-react';
import style from './GalleryItem.module.scss';
import 'video-react/dist/video-react.css';
const GalleryItem = t0 => {
  const $ = _c(15);
  const {
    url,
    mimeType
  } = t0;
  const [play, setPlay] = useState(false);
  const playerRef = useRef(null);
  let t1;
  if ($[0] !== url) {
    t1 = url.replace(/ /g, "%20").replace("http://", "https://");
    $[0] = url;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const urlSrc = t1;
  let t2;
  let t3;
  if ($[2] !== play) {
    t2 = () => {
      if (playerRef?.current && play) {
        playerRef.current.play();
      }
    };
    t3 = [playerRef, play];
    $[2] = play;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== mimeType || $[6] !== play || $[7] !== urlSrc) {
    t4 = mimeType?.includes("video") && <Player className={style.player} ref={playerRef}><source src={`${urlSrc}#t=0.001`} />{!play && <button className={style.play} onClick={() => setPlay(true)}><div className={style.play__icon}><Svg src={playIcon.src} /></div></button>}<ControlBar autoHide={false}><ReplayControl seconds={10} order={1.1} /><ForwardControl seconds={30} order={1.2} /><CurrentTimeDisplay order={4.1} /><TimeDivider order={4.2} /><PlaybackRateMenuButton rates={[5, 2, 1, 0.5, 0.1]} order={7.1} /><VolumeMenuButton /></ControlBar></Player>;
    $[5] = mimeType;
    $[6] = play;
    $[7] = urlSrc;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== mimeType || $[10] !== urlSrc) {
    t5 = mimeType?.includes("image") && <ImgWrapper imgUrl={urlSrc} alt="image" />;
    $[9] = mimeType;
    $[10] = urlSrc;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t4 || $[13] !== t5) {
    t6 = <>{t4}{t5}</>;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
};
export default GalleryItem;